var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5C4.55228 8.5 5 8.05229 5 7.5C5 6.94771 4.55228 6.5 4 6.5C3.44772 6.5 3 6.94771 3 7.5C3 8.05229 3.44772 8.5 4 8.5Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5C5 11.0523 4.55228 11.5 4 11.5C3.44772 11.5 3 11.0523 3 10.5C3 9.94771 3.44772 9.5 4 9.5C4.55228 9.5 5 9.94771 5 10.5Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5C7.55229 8.5 8 8.05229 8 7.5C8 6.94771 7.55229 6.5 7 6.5C6.44771 6.5 6 6.94771 6 7.5C6 8.05229 6.44771 8.5 7 8.5Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5C8 11.0523 7.55229 11.5 7 11.5C6.44771 11.5 6 11.0523 6 10.5C6 9.94771 6.44771 9.5 7 9.5C7.55229 9.5 8 9.94771 8 10.5Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C10.5523 8.5 11 8.05229 11 7.5C11 6.94771 10.5523 6.5 10 6.5C9.44771 6.5 9 6.94771 9 7.5C9 8.05229 9.44771 8.5 10 8.5Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3C14 1.61929 12.8807 0.5 11.5 0.5H2.5C1.11929 0.5 0 1.61929 0 3V12C0 13.3807 1.11929 14.5 2.5 14.5H11.5C12.8807 14.5 14 13.3807 14 12V3ZM1 4.5H13V12C13 12.8284 12.3284 13.5 11.5 13.5H2.5C1.67157 13.5 1 12.8284 1 12V4.5ZM2.5 1.5H11.5C12.3284 1.5 13 2.17157 13 3V3.5H1V3C1 2.17157 1.67157 1.5 2.5 1.5Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ea75a96a8e98bfd255a8de7af91a306b.svg";
export { ForwardRef as ReactComponent };